import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import CTASection from '../components/CTASection';
import ParallaxBanner from '../components/ParallaxBanner';
import FeaturedIssue from '../components/FeaturedIssue';
import QuickLinks from '../components/QuickLinks';
import Reveal from '../components/Reveal';

const PUB = process.env.PUBLIC_URL;

const teasers = [
  {
    eyebrow: 'About',
    title: 'A Big Flats family. A lifetime of work.',
    body: 'Ron’s family has called Big Flats home for 107 years. He’s built businesses, raised three sons, and knows how small towns really work.',
    to: '/about',
    label: 'Meet Ron',
  },
  {
    eyebrow: 'Values',
    title: 'Honest. Transparent. Efficient.',
    body: 'The same principles Ron has used to run businesses and raise a family are the ones he’ll bring to the county legislature.',
    to: '/values',
    label: 'See What He Stands For',
  },
  {
    eyebrow: 'Priorities',
    title: 'A real plan for Big Flats.',
    body: 'Transparent planning. Smart growth. Holding the line on taxes. Six clear priorities Ron will work on from day one.',
    to: '/priorities',
    label: 'View Priorities',
  },
];

function Home() {
  return (
    <>
      <Hero />

      <section className="section">
        <div className="container">
          <Reveal>
            <div className="section__eyebrow">The Campaign</div>
            <h2 className="section__title">Why Ron is Running</h2>
            <p className="section__lead">
              Big Flats is growing &mdash; and that&rsquo;s a good thing, if we
              grow the right way. Ron Johanson is running to make sure decisions
              in our town are transparent, fair, and built around the people who
              actually live here.
            </p>
          </Reveal>

          <div className="home-teasers">
            {teasers.map((t, i) => (
              <Reveal as="article" className="home-teaser" key={t.to} delay={i * 90}>
                <div className="home-teaser__eyebrow">{t.eyebrow}</div>
                <h3>{t.title}</h3>
                <p>{t.body}</p>
                <Link to={t.to} className="home-teaser__link">
                  {t.label} &rarr;
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <FeaturedIssue />

      <QuickLinks />

      <ParallaxBanner
        image={`${PUB}/media/banner-home.jpg`}
        eyebrow="Rooted in Big Flats"
        title="A family that calls this place home."
        body="Three sons, a century of roots, and a town worth fighting for. Get to know the family behind the campaign."
        ctaLabel="Meet the Family"
        ctaTo="/family"
      />

      <CTASection />
    </>
  );
}

export default Home;
